import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ConfirmationModal from '../shared/confirmation-modal'
import { dismissErrorDialog } from '../../actions'
import { MW_ERROR_MESSAGES } from '../../constants'
import { useConfig } from '../../hooks/use-config'
import { findConfigValue } from '../../lib/config'

const streamingLimitErrorMessages = [
  MW_ERROR_MESSAGES.STREAMING_LIMIT_SVOD,
  MW_ERROR_MESSAGES.STREAMING_LIMIT_SVOD_UPGRADE
]

const selectErrorMessage = ({ error }) => {
  if (streamingLimitErrorMessages.includes(error.message)) {
    return MW_ERROR_MESSAGES.STREAMING_LIMIT_NEON
  }

  return error.message
}

/**
 * Displays the current application error in a confirmation modal
 * and dismisses it through Redux when confirmed.
 */
function ErrorDialog() {
  const dispatch = useDispatch()
  const errorMessage = useSelector(selectErrorMessage)
  const { appConfig, deviceFingerprint } = useConfig()

  if (!deviceFingerprint || !errorMessage) {
    return null
  }

  const errorHeader = findConfigValue('MODAL_TITLE_WARNING')(appConfig)

  return (
    <ConfirmationModal
      header={errorHeader}
      message={errorMessage}
      confirmText="OK"
      onConfirmClick={() => dispatch(dismissErrorDialog())}
    />
  )
}

export default ErrorDialog
